import React, { useState } from "react";
import {
  Button,
  Typography,
  Row,
  Col,
  InputNumber,
  Popover,
  Tag,
  Divider,
  Radio,
  Card,
} from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

const { Text } = Typography;


const initialData = Array(8)
  .fill({})
  .map((_, i) => ({
    key: i,
    mspc: "KARWAR",
    project: "ARIDHAL",
    rice: 1.0,
    wheat: 0.56,
    sambarMasala: 0.2,
    soya: 0.2,
    coriander: 0.2,
    chillyPowder: 0.3,
    total: 0.9,
  }));

const EditableCounter = ({ value, onChange }) => {
  const [visible, setVisible] = useState(false);
  const [counter, setCounter] = useState(value);

  const handleSave = () => {
    onChange(counter);
    setVisible(false);
  };

  return (
    <Popover
      content={
        <div style={{ padding: 8, minWidth: 160 }}>
          <div
            style={{
              fontWeight: "bold",
              marginBottom: 8,
              backgroundColor: "#E6F4FF",
              padding: 8,
              borderRadius: 4,
              textAlign: "center",
              color: "#1677FF",
            }}
          >
            Edit Counts
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <Button icon={<MinusOutlined />} onClick={() => setCounter(counter - 0.1)} />
            <InputNumber
              min={0}
              step={0.1}
              precision={2}
              value={counter}
              onChange={(val) => setCounter(val)}
              style={{ width: 70 }}
            />
            <Button icon={<PlusOutlined />} onClick={() => setCounter(counter + 0.1)} />
          </div>
          <Button type="primary" block onClick={handleSave}>
            Save
          </Button>
        </div>
      }
      trigger="click"
      open={visible}
      onOpenChange={(vis) => setVisible(vis)}
    >
      <Text style={{ cursor: "pointer", color: "#1890ff" }}>
        {value.toFixed(2)} T
      </Text>
    </Popover>
  );
};

const RM_Cal = () => {
  const [data, setData] = useState(initialData);
  const [tab, setTab] = useState("All");

  const handleCellChange = (key, field, value) => {
    const newData = data.map((item) =>
      item.key === key
        ? {
            ...item,
            [field]: value,
            total: calculateTotal({ ...item, [field]: value }),
          }
        : item
    );
    setData(newData);
  };

  const calculateTotal = (item) => {
    return parseFloat(
      (
        (item.rice || 0) +
        (item.wheat || 0) +
        (item.sambarMasala || 0) +
        (item.soya || 0) +
        (item.coriander || 0) +
        (item.chillyPowder || 0)
      ).toFixed(2)
    );
  };

  const resetData = () => setData(initialData);

  return (
    <div style={{ padding: 24, background: "#f9f9f9", minHeight: "100vh" }}>
     
     <Row style={{display:"flex",flexDirection:"row",justifyContent:"flex-end"}}>
      <Radio.Group
        value={tab}
        onChange={(e) => setTab(e.target.value)}
        style={{ marginBottom: 20 }}
        buttonStyle="solid"
      >
        <Radio.Button value="All">All</Radio.Button>
        <Radio.Button value="Production">Production</Radio.Button>
        <Radio.Button value="Kit">Kit</Radio.Button>
      </Radio.Group>
</Row>
      
      <Card bordered={false} style={{ borderRadius: "10px" }}>
      <Row
  style={{
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    rowGap: 10,
    marginBottom: "15px",
  }}
>
  <Col style={{ display: "flex", alignItems: "center", gap:"15px" }}>
    <Text strong style={{ fontSize: 16 }}>KTKKAR0825</Text>
    <Text>JUN 2025</Text>
    <Text>140000</Text>
    <Button type="primary">KIT 1</Button>
  </Col>
</Row>

     
    
      <Card bordered={false} style={{ borderRadius: "5px",border:"1px solid #BFB7B7" }}>
      <div
       style={{
      display: "flex", 
      marginBottom: 8,
      background: "#e9eef7",
      borderRadius: 8,
      alignItems: "center",
      height: 40, 
      border:"1px solid #BFB7B7",   
        }}
      >
        
        <div style={{ flex: 1, minWidth: 110 }}>
          <Text strong>MSPC NAME</Text>
        </div>
        <div style={{ flex: 1, minWidth: 110 }}>
          <Text strong>Project</Text>
        </div>
        {["Rice", "Wheat", "Sambar Masala", "Soya", "Coriander", "Chilly Powder"].map((label) => (
          <div key={label} style={{ minWidth: 110, textAlign: "center" }}>
            <Text strong>{label}</Text>
          </div>
        ))}
        <div style={{ width: 80, textAlign: "center" }}>
          <Text strong>Total</Text>
        </div>
      </div>

    
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {data.map((item) => (
          <div
            key={item.key}
            style={{
              display: "flex",
              alignItems: "center",
              padding: 16,
              background: "#fff",
              borderRadius: "5px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              gap: 12,
              border:"1px solid #BFB7B7",
            }}
          >
            <div style={{ flex: 1 }}>{item.mspc}</div>
            <div style={{ flex: 1 }}>{item.project}</div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <EditableCounter value={item.rice} onChange={(val) => handleCellChange(item.key, "rice", val)} />
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <EditableCounter value={item.wheat} onChange={(val) => handleCellChange(item.key, "wheat", val)} />
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <EditableCounter value={item.sambarMasala} onChange={(val) => handleCellChange(item.key, "sambarMasala", val)} />
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <EditableCounter value={item.soya} onChange={(val) => handleCellChange(item.key, "soya", val)} />
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <EditableCounter value={item.coriander} onChange={(val) => handleCellChange(item.key, "coriander", val)} />
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <EditableCounter value={item.chillyPowder} onChange={(val) => handleCellChange(item.key, "chillyPowder", val)} />
            </div>
            <div style={{ width: 60, textAlign: "center", fontWeight: "bold" }}>{item.total.toFixed(2)} T</div>
          </div>
        ))}
      </div>

    
      <div style={{ marginTop: 20, display: "flex",flexDirection:"row",justifyContent:"flex-end" ,gap: 10 }}>
        <Button onClick={resetData}>RESET TO ORIGINAL</Button>
        <Button type="primary">UPDATE</Button>
      </div>
</Card>
      
      <div style={{ marginTop: 24 }}>
        <Text type="secondary">
          Changes made From Original &nbsp;
          <a href="#">View All</a>
        </Text>
        <div style={{ marginTop: 8 }}>
          <Tag color="blue">MSPC Soya</Tag> qty increased From 1T - 2T
        </div>
        <div>
          <Tag color="blue">MSPC Oil</Tag> qty increased From 1T - 2T
        </div>
      </div>
      </Card>
    </div>
  );
};

export default RM_Cal;
